import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys';
import { fetchRecords } from '../../lib/api';

export function useRecords(params) {
  const { constituency_id, campaign_id, page = 1, page_size = 50, search, status_filter, block_filter, voted_filter } = params ?? {};
  const filters = { search, status_filter, block_filter, voted_filter };

  return useQuery({
    queryKey: queryKeys.records(constituency_id, campaign_id, page, filters),
    queryFn: () => fetchRecords({
      constituency_id,
      campaign_id,
      page,
      page_size,
      ...(search && { search }),
      ...(status_filter && status_filter !== '__all__' && { status_filter }),
      ...(block_filter && block_filter !== '__all__' && { block_filter }),
      ...(voted_filter && voted_filter !== '__all__' && { voted_filter }),
    }),
    enabled: !!(constituency_id && campaign_id),
  });
}
